var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading_page ma-0 pa-0"},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v("Chargement des départs...")]),_c('v-progress-linear',{attrs:{"indeterminate":"","color":"depart_pink","rounded":"","height":"6"}}),_c('p',[_vm._v("En cas de chargement trop long, essayez de rafraichir la page.")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }